import React, { useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from "axios";
import params from "../../config/Params";
import PayoutMethod from "./components/PayoutMethod";
import AccountType from "./components/AccountType";
import BankAccountInfo from "./components/BankAccountInfo";
import AddressDetails from "./components/AddressDetails";
import ReviewInfo from "./components/ReviewInfo";
import { getItemFromLocalStorage } from '../../utils/storageUtils';
import { toast } from 'react-toastify';

const AddPayoutOption = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    payoutMethod: null,
    accountType: null,
    payout_method_id: "",
    first_name: "",
    last_name: "",
    business_name: "",
    role_id: "",
    bankType: null,
    accountNumber: "",
    confirmAccountNumber: "",
    ifsCode: "",
    bankName: "",
    streetAddress: "",
    landmark: "",
    city: "",
    state: "",
    postalCode: "",
    panNumber: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [activeIndex, setActiveIndex] = useState(null);

  const payoutMethodRef = useRef(null);
  const accountTypeRef = useRef(null);
  const bankAccountInfoRef = useRef(null);
  const addressDetailsRef = useRef(null);

  const steps = [
    { title: "Payout Method", component: PayoutMethod, ref: payoutMethodRef },
    { title: "Account Type", component: AccountType, ref: accountTypeRef },
    { title: "Bank Account Info", component: BankAccountInfo, ref: bankAccountInfoRef },
    { title: "Address Details", component: AddressDetails, ref: addressDetailsRef },
    { title: "Review info", component: ReviewInfo },
  ];

  const validateCurrentStep = () => {
    const currentStepComponent = steps[currentStep];
    if (currentStepComponent && currentStepComponent.ref.current && typeof currentStepComponent.ref.current.validate === 'function') {
      const errors = currentStepComponent.ref.current.validate();
      setFormErrors(errors);
      return Object.keys(errors).length === 0;
    }
    return true;
  };

  const handleNext = () => {
    if (currentStep == 1){
      if (!formData.role_id){
        toast.error("Please select Role")
        return
      }
    }
    if (currentStep < steps.length - 1) {
      const isValid = validateCurrentStep();
      if (isValid) {
        setCurrentStep(prev => prev + 1);
        setFormErrors({});
      } else {
        toast.error("Please correct the errors on this page.");
      }
    } else {
      handleSubmit();
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
      setFormErrors({});
    }
  };

  const handleSubmit = async (e) => {
    console.log("Final submitted data:", formData);
    const hostData = getItemFromLocalStorage('hostProfile');
    const ts = Date.now();

    const payoutData = {
      payout_method_id: formData.payout_method_id,
      bank_account_holder_type_id: formData.accountType?.id || '',
      bank_account_holder_personal_first_name: formData.first_name || '',
      bank_account_holder_personal_last_name: formData.last_name || '',
      bank_account_holder_business_name: formData.business_name || '',
      bank_account_holder_role_id: formData.role_id || '',
      bank_account_type_id: formData.accountType?.id || '',
      bank_account_number: formData.accountNumber || '',
      bank_account_ifsc_code: formData.ifsCode || '',
      bank_name: formData.bankName || '',
      bank_street_address: formData.streetAddress || '',
      bank_bldg_name: formData.landmark || '',
      bank_city: formData.city || '',
      bank_state: formData.state || '',
      bank_pincode: formData.postalCode || '',
      pan_card_number: formData.panNumber || '',
    }

    let apiData = new FormData();
    apiData.append('token', hostData.host_access_token);
    apiData.append('data', JSON.stringify(payoutData));
    apiData.append('ts', ts);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: `${params.baseURL}${params.endpoints.payoutAddMethod}`,
        data: apiData
      });

      console.log(response.data)

      if (response.data.status === 'done') {
        navigate('/payouts/');
        setTimeout(() => {
          toast.success('Payout details saved successfully.');
        }, 300);
      } else if (response.data.status == 'error') {
        toast.error(response.data.list[0]);
      } else {
        toast.error('Error in saving data.');
      }
    } catch (err) {
      toast.error('An error occurred while saving data.');
    }

  };

  const StepComponent = steps[currentStep].component;
  const currentStepRef = steps[currentStep].ref;

  const faqs = [
    {
      question: "What is Lorem Ipsum?",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
      question: "Where does it come from?",
      answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <Helmet>
        <title>Add Payout Option</title>
      </Helmet>

      {/*<div className="step-header">
                <h4>{steps[currentStep].title}</h4>
            </div>*/}

      <div className="row">
        <div className="col-md-6">
          <div className="step-content">
            <StepComponent formData={formData} setFormData={setFormData} ref={currentStepRef} />
            {/*{Object.keys(formErrors).length > 0 && (
                      <div className="error-message">
                          {Object.values(formErrors).map(error => (
                              <p key={error}>{error}</p>
                          ))}
                      </div>
                  )}*/}
          </div>

          <div className='clp-footer' style={{ width: '50%', padding: '20px 0', paddingLeft: '42px', paddingRight: '12px' }}>
            <button className='btn btn-blank' onClick={handlePrevious} disabled={currentStep === 0} >Back</button>
            <button className='btn btn-black' onClick={handleNext}>
              {currentStep === steps.length - 1 ? "Submit" : "Next"}
            </button>
          </div>
        </div>
        <div className="col-md-2"></div>
        <div className='col-md-4 p-0'>
          <div className='bfhsd'>
            <div className='blog-box'>
              <div class="blog">
                <div class="blog-image">
                  <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                  <div class="date">May 08, 2025</div>
                </div>
                <div class="blog-content">
                  <h2>What is Lorem Ipsum?</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                  <a href="#">Read More</a>
                </div>
              </div>
            </div>
            <div className="faq-sticky">
              {faqs.map((faq, index) => (
                <div key={index} className='faqs-list-section'>
                  <div
                    onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                    style={{
                      backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                    }}
                  >
                    {faq.question}
                    <i
                      className={`fas ${activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                        }`}
                      style={{
                        transition: "transform 0.3s ease",
                      }}
                    ></i>
                  </div>
                  {activeIndex === index && (
                    <div className='faqs-ans-box'>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AddPayoutOption;